import React from "react"
import {connect} from "react-redux";
import OrderSummary from "../../containers/common/OrderSummary";
import {getOrderData} from "../../actions/account/accountActions";
import {isFetching} from "../../actions/common/fetchingActions";
import LoadingAnimation from "../../components/common/LoadingAnimation";
import {FetchingTypes} from "../../common/constants";
import {translate} from '../../i18n/translate.js';

class AccountWebOrderView extends React.Component {
    componentWillMount() {
        this.props.getOrderData(this.props.webOrder.orderKey);
    }

    render() {
        if(!this.props.isFetching) {
            return (
                <div className="summary-order-wrapper">
                    <div className="order-summary-header-container">
                        <i className="cart-icon"/>
                        <div className="order-title">{translate("Web Order")}</div>
                        <div className="close-modal" onClick={this.props.onClose}>X</div>
                    </div>
                    <div className="order-summary-container">
                        <OrderSummary orderDate={(this.props.webOrder||{}).orderDate} hideRecurring={true}/>
                    </div>
                </div>
            );
        } else {
            return (<LoadingAnimation/>);
        }
    }
}

const mapStateToProps = (state) => {
    return {
        isFetching: isFetching(state, FetchingTypes.LOAD_ORDER_DATA),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getOrderData: (orderKey) => {
            dispatch(getOrderData(orderKey));
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps) (AccountWebOrderView);



// WEBPACK FOOTER //
// ./src/components/account/AccountWebOrderView.js